import { client } from "../../../api/client";

export const fetchItemLookupType = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_itemLookupTypeData.json");
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookuptype");
            return response.data;
        } catch (error) {
            console.error("Error fetching Item Lookup Type:", error);
            return [];
        }
    }
};

export const getAllItemLookupTypes = async () => {
    const itemLookupTypes = await fetchItemLookupType();

    const parsedItemLookupTypes = itemLookupTypes.map(lookupType => {
        let parsedCustomAttributes;
        try {
            const customAttrs = lookupType.customAttributes;
            if (customAttrs && typeof customAttrs === 'string' && customAttrs.trim()) {
                parsedCustomAttributes = JSON.parse(customAttrs);
            } else {
                parsedCustomAttributes = [];
            }
        } catch (e) {
            console.warn('Failed to parse customAttributes for itemType:', lookupType.id, e);
            parsedCustomAttributes = [];
        }

        return {
            ...lookupType,
            customAttributes: Array.isArray(parsedCustomAttributes) ? parsedCustomAttributes : [],
        };
    });

    return parsedItemLookupTypes;
};

export const fetchItemLookupTypeByFilters = async (filters) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_itemLookupTypeData.json");
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookuptype/filter", filters);
            return response.data;
        } catch (error) {
            console.error("Error fetching Item Lookup Type:", error);
            return [];
        }
    }
};

export const fetchItemLookupTypeCustomAttributes = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return [];
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookuptype/customattributes");
            return response.data;
        } catch (error) {
            console.error("Error fetching item lookup type custom attributes:", error);
            return [];
        }
    }
};

export const createItemLookupType = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookuptype", body);
            return response.data;
        } catch (error) {
            console.error("Error creating Item Lookup Type:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
}

export const updateItemLookupType = async (id, body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `iquoteapi/itemlookuptype/${id}`, body);
            return response.data;
        } catch (error) {
            console.error("Error updating Item Lookup Type:", error);
            return [];
        }
    } else {
        return [];
    }
}

export const deleteItemLookupType = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.delete(process.env.REACT_APP_GATEWAY_URI, `iquoteapi/itemlookuptype/${id}`);
            return response.ok;
        } catch (error) {
            console.error("Error deleting Item Lookup Type:", error);
            return false;
        }
    } else {
        return true;
    }
}